import React from 'react';
import { PLAN_COMMERCIAL_META_ES } from '../../utils/planDetails';
import { PLAN_LABELS_ES } from '../../utils/planTiers';

/**
 * START | EMPRESA compacto en móvil / tablet vertical (sin laterales).
 */
export default function LoginPlansMobileStrip({ onVerPlan }) {
  const plans = [
    { id: 'basic', label: PLAN_LABELS_ES.basic },
    { id: 'premium', label: PLAN_LABELS_ES.premium }
  ];

  return (
    <div className="mb-4 grid grid-cols-2 gap-2 lg:hidden">
      {plans.map(({ id, label }) => {
        const meta = PLAN_COMMERCIAL_META_ES[id];
        return (
          <button
            key={id}
            type="button"
            onClick={() => onVerPlan?.(id)}
            className="rounded-xl border border-white/12 bg-black/35 px-3 py-2.5 text-left transition hover:bg-white/[0.06]"
          >
            <p className="text-sm font-bold text-e0e3-foreground">{label}</p>
            <p className="mt-0.5 text-[11px] text-e0e3-muted">
              {meta.includedUsers} usuarios · {meta.includedBranches}{' '}
              {meta.includedBranches === 1 ? 'sucursal' : 'sucursales'}
            </p>
          </button>
        );
      })}
    </div>
  );
}
